"use client";

import { AuthGatewayProviders } from "@miadvg/auth-gateway/next-client";
import { ConfigProvider } from "@miadvg/config";
import { PostHogProvider } from "@miadvg/posthog";
import {
  TEMPLATE_STAFF_APP_SLUG,
  TEMPLATE_STAFF_AUTH_CALLBACK_PATH,
  TEMPLATE_STAFF_SIGN_OUT_PATH,
} from "@/lib/auth/staff-shared";
import { Toaster } from "@/components/ui/sonner";

interface ProvidersProps {
  children: React.ReactNode;
}

/**
 * Client-side providers wrapper
 *
 * ConfigProvider: Fetches runtime config from /api/config
 * PostHogProvider: Initializes PostHog after config is ready
 *
 * Product events: `captureEvent`. Feature flags: `useServiceFlagEnabled` /
 * `createServiceFlagHooks` from `@miadvg/posthog`. Raw `posthog-js/react` only
 * when you need APIs this package does not wrap (e.g. `usePostHog`).
 */
export function Providers({ children }: ProvidersProps) {
  return (
    <ConfigProvider>
      <PostHogProvider
        options={{
          api_host: '/ingest',
          ui_host: 'https://us.i.posthog.com',
        }}
      >
        <AuthGatewayProviders
          staff={{
            appSlug: TEMPLATE_STAFF_APP_SLUG,
            callbackPath: TEMPLATE_STAFF_AUTH_CALLBACK_PATH,
            signOutPath: TEMPLATE_STAFF_SIGN_OUT_PATH,
          }}
          client={{
            sessionEndpointPath: "/api/client/session",
          }}
        >
          {children}
          <Toaster />
        </AuthGatewayProviders>
      </PostHogProvider>
    </ConfigProvider>
  );
}
